<div class="component-search" [class.component-search--compact]="searchCompact">
  <h1 *ngIf="searchCompact">Fordham Analytics</h1>
  <h2 *ngIf="searchCompact">What would you like to know today?</h2>
  <input type="text" class="js-main-search" [class.has-text]="searchQuery" placeholder="{{placeholderText}}"
         [(ngModel)]="searchQuery" (click)="emitSearchQuery()" (keyup)="emitSearchQuery(true)" (keydown.enter)="scrollToReports()">
  <p class="component-search__clear-button" *ngIf="searchQuery" (click)="resetSearchQuery()">Clear</p>
</div>
